function StatusInvoices({value, onChange}) {

    return (
        <select value={value} onChange={(event) => onChange(event.target.value)} className={"status-invoices"}>
            <option value={1}> אושר </option>
            <option value={0}> ממתין לאישור </option>
            <option value={2}> בוטל </option>
            <option value={3}> מחיקה </option>
        </select>
    )
}


export default StatusInvoices;